module.exports = __webpack_public_path__ + "static/media/shop-close.e8a04f9e.png";